import { PlansService } from "@/clients/services/PlansService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

interface UseGetCalorieBudgetOptions {
  enabled?: boolean;
}

export const useGetCalorieBudget = (options?: UseGetCalorieBudgetOptions) => {
  const { data, isLoading, error } = useQuery({
    queryKey: [QueryKeys.CALORIE_BUDGET],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await PlansService.getNutritionalInfoApiV1PlansNutritionalInfoGet(
          user.id,
        );
      return data;
    },
    enabled: options?.enabled ?? true,
    retry: (failureCount, error) => {
      // Don't retry on 404 errors
      if (error instanceof Error && error.message.includes("404")) {
        return false;
      }
      return failureCount < 2;
    },
  });

  return { calorieBudget: data, isLoading, error };
};
